import { PeakExceptionResponseCode, PeakPayrollExceptionCode } from "@/enums/enums";
import { i18n } from "@/i18n";
import { TranslateResult } from "vue-i18n";

export function GetErrorMessageByPayrollExceptionCode(exception: any) {
  let errorMessage: TranslateResult | string = "";

  switch (exception.code) {
    case PeakPayrollExceptionCode.IsHaveEmployee:
      errorMessage = i18n.t("Exceptions_Notification.IsHaveEmployee");
      break;
    case PeakPayrollExceptionCode.IsHaveSalaryEmployee:
      errorMessage = i18n.t("Exceptions_Notification.IsHaveSalaryEmployee");
      break;
    case PeakPayrollExceptionCode.CodeDuplicated:
      errorMessage = i18n.t("Exceptions_Notification.Pay_Run_Code_Duplicated", {
        number: exception.content,
      });
      break;
    case PeakPayrollExceptionCode.CodeIsEmpty:
      errorMessage = i18n.t("Exceptions_Notification.CodeIsEmpty", {
        text: i18n.t("Pay_Run_Code"),
      });
      break;
    case PeakPayrollExceptionCode.BasicCreateSalary:
      errorMessage = i18n.t("Exceptions_Notification.BasicCreateSalary");
      break;
    case PeakPayrollExceptionCode.ProplusCreateSummarySalaryPeriod:
      errorMessage = i18n.t("Exceptions_Notification.ProplusCreateSummarySalaryPeriod");
      break;
    case PeakPayrollExceptionCode.CanNotPaidBeforeIssueDate:
      errorMessage = i18n.t("Exceptions_Notification.CanNotPaidBeforeIssueDate");
      break;
    case PeakPayrollExceptionCode.PositionCodeDuplicated:
      errorMessage = i18n.t("Exceptions_Notification.PositionCodeDuplicated");
      break;
    case PeakPayrollExceptionCode.CanNotCreateRecordAccrued:
    case PeakPayrollExceptionCode.CanNotCreateSSOExpense:
    case PeakPayrollExceptionCode.CanNotCreatePaidSaraly:
    case PeakPayrollExceptionCode.CanNotVoidSalaryDocument:
      errorMessage = i18n.t("Document_Has_Been_Changed");
      break;
    default:
      errorMessage = exception.code
        ? `${i18n.t("Something_Wrong")} Error Code : ${exception.code}`
        : i18n.t("Something_Wrong");
      break;
  }

  return errorMessage;
}

export function GetErrorMessageByExceptionCode(exception: any) {
  let errorMessage: TranslateResult | string = "";

  switch (exception.code) {
    case PeakExceptionResponseCode.TransactionNumberDuplicated:
      errorMessage = i18n.t("Duplicated_Document_Number");
      break;
    case PeakExceptionResponseCode.ContactNotFound:
      errorMessage = i18n.t("Select_Contact_Failed_Because_Contact_Was_Archived");
      break;
    case PeakExceptionResponseCode.LockByPeriod:
      errorMessage = i18n.t("LockPeriod_Alert") + new Date(exception.content).ToDateJsonString();
      break;
    case PeakExceptionResponseCode.LockByUser:
      errorMessage = i18n.t("Exception_Journal_Lock");
      break;
    case PeakExceptionResponseCode.CanNotSetDueDateBeforeTransactionDate:
      errorMessage = i18n.t("Cant_Set_Duedate_Before_Transaction_Date");
      break;
    case PeakExceptionResponseCode.CanNotVoidInvoiceIsIssuedBillingNote:
      errorMessage = i18n.t("Can_Not_Void_Invoice_IsIssued_BillingNote");
      break;
    case PeakExceptionResponseCode.CanNotVoidInvoiceIsIssuedCreditNote:
      errorMessage = i18n.t("Can_Not_Void_Invoice_IsIssued_CreditNote");
      break;
    case PeakExceptionResponseCode.AccountNotFound:
      errorMessage = i18n.t("Some_Accounts_Has_Deleted");
      break;
    case PeakExceptionResponseCode.PaymentTransactionIsReconciled:
      errorMessage = i18n.t("Document_Has_Been_Reconcile");
      break;
    default:
      errorMessage = exception.code
        ? `${i18n.t("Something_Wrong")} Error Code : ${exception.code}`
        : i18n.t("Something_Wrong");
      break;
  }

  return errorMessage;
}
